import datepicker from 'js-datepicker';
import Inputmask from 'inputmask';

export const formatDatePicker = (date: any) => {
    let value = null;
    if (date.value) {
        value = date.value.split('.');
        value = new Date(value[2], value[1] - 1, value[0]);
    }
    let options = {
        overlayButton: 'Выбрать',
        overlayPlaceholder: 'Введите год',
        customDays: ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'],
        customMonths: [
            'Январь',
            'Февраль',
            'Март',
            'Апрель',
            'Май',
            'Июнь',
            'Июль',
            'Август',
            'Сентябрь',
            'Октябрь',
            'Ноябрь',
            'Декабрь',
        ],
        startDate: value,
        startDay: 1,
        formatter: (input, date, instance) => {
            const value = date.toLocaleDateString();
            input.value = value;
        },
        dateSelected: value,
        onShow: () => {
            date.dispatchEvent(new Event('change'));
        },
        onSelect: () => {
            date.dispatchEvent(new Event('change'));
            date.dispatchEvent(new Event('input'));
            date.dispatchEvent(new Event('blur'));
        },
    };

    if (date.getAttribute('data-min')) {
        let minDate = date.getAttribute('data-min');
        minDate = minDate.split('.');
        minDate = new Date(minDate[2], minDate[1] - 1, minDate[0]);
        options = {
            ...options,
            ...{
                minDate,
            },
        };
        if (value) {
            if (value.getTime() < minDate.getTime()) {
                options.startDate = minDate;
            }
        } else {
            options.startDate = minDate;
        }
    }
    if (date.getAttribute('data-max')) {
        let maxDate = date.getAttribute('data-max');
        maxDate = maxDate.split('.');
        maxDate = new Date(maxDate[2], maxDate[1] - 1, maxDate[0]);
        options = {
            ...options,
            ...{
                maxDate,
            },
        };
        if (value) {
            if (value.getTime() > maxDate.getTime()) {
                options.startDate = maxDate;
            }
        } else {
            options.startDate = maxDate;
        }
    }
    if (date.getAttribute('data-range')) {
        const range = date.getAttribute('data-range');
        options = {
            ...options,
            ...{
                id: range,
            },
        };
    }

    const picker = datepicker(date, options);

    Inputmask('datetime', {
        inputFormat: 'dd.mm.yyyy',
        showMaskOnHover: false,
        placeholder: '_',
    }).mask(date);
};

document.addEventListener('DOMContentLoaded', () => {
    const dates = document.querySelectorAll('.js-date');
    dates.forEach((date) => {
        formatDatePicker(date);
    });
});
